import { render, staticRenderFns } from "./OCRConfigure.vue?vue&type=template&id=46d4083a&scoped=true"
import script from "./OCRConfigure.vue?vue&type=script&lang=js"
export * from "./OCRConfigure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d4083a",
  null
  
)

export default component.exports